import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Btn } from "@/admin/AdminLayout";

const fmt = (d: string) => new Date(d).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

export function ActivityFeed() {
  const [rows, setRows] = useState<any[]>([]);
  const [more, setMore] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = async (skip: number) => {
    setBusy(true);
    try { const r = (await api.get("/admin-x/activity", { params: { skip, limit: 25 } })).data; setRows((x) => (skip ? [...x, ...r.items] : r.items)); setMore(r.has_more); } finally { setBusy(false); }
  };
  useEffect(() => { load(0); }, []);
  return (
    <div className="mt-10" data-testid="activity-feed">
      <p className="eyebrow text-[10px] text-neutral-500 mb-3">Staff activity · latest saves</p>
      <div className="bg-white border border-neutral-200">
        {!rows.length ? <p className="p-5 text-sm text-neutral-500" data-testid="activity-empty">{busy ? "Loading…" : "No saves recorded yet."}</p> : (
          <ul className="divide-y divide-neutral-100">
            {rows.map((r, i) => (
              <li key={r.id} className="px-5 py-3 flex flex-wrap items-baseline gap-x-2 text-sm" data-testid={`activity-row-${i}`}>
                <span className="font-medium">{r.by}</span>
                <span className="text-neutral-600">{r.action}</span>
                <span className="text-neutral-500">{r.kind}</span>
                {r.url ? <a href={r.url} target="_blank" rel="noreferrer" className="underline underline-offset-2">{r.title}</a> : <span>{r.title}</span>}
                <span className="ml-auto text-xs text-neutral-500 whitespace-nowrap">{fmt(r.at)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      {more && <Btn ghost className="mt-3" disabled={busy} onClick={() => load(rows.length)} data-testid="activity-more">{busy ? "Loading…" : "Show more"}</Btn>}
    </div>
  );
}
